export default __webpack_public_path__ + "dcb7cd7b64a899c622fd7916b632c34c.png";